import {useState} from "react";
import notifier from "simple-react-notifications2";
import {CountersignDto} from "../../model/order/countersign";
import {customAxios} from "../customAxios";

export function useCheckCountersign() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<CountersignDto>();
    const [error, setError] = useState<Error>();

    async function execute(tenantId: number, countersignId: number) {
        try {
            setLoading(true);
            const fetched = await checkCountersign(tenantId, countersignId);
            setData(fetched);
            return fetched;
        }
        catch (e) {
            setError(e as Error);
            notifier.error((e as Error).message)
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {loading, data, error, execute};
}



export async function checkCountersign(tenantId: number, countersignId: number): Promise<CountersignDto> {
    const response = await customAxios.put<CountersignDto>(`/v1/order/tenant/${tenantId}/countersign/${countersignId}/check`);
    return response.data;
}